// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_status_enum */
var TestStatusEnum;
(function (TestStatusEnum) {
    TestStatusEnum["PLANNED"] = "PLANNED";
    TestStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    TestStatusEnum["COMPLETED"] = "COMPLETED";
    TestStatusEnum["CANCELLED"] = "CANCELLED";
})(TestStatusEnum || (TestStatusEnum = {}));
;
export default TestStatusEnum;
/** Zod schema for test_status_enum */
export const testStatusEnum = z.nativeEnum(TestStatusEnum);
//# sourceMappingURL=TestStatusEnum.js.map